import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { compose } from 'recompose';
import _map from 'lodash/map';
import _find from 'lodash/find';
import _head from 'lodash/head';
import _property from 'lodash/property';
import _curry from 'lodash/curry';
import _get from 'lodash/get';
import _omitBy from 'lodash/omitBy';
import _isNil from 'lodash/isNil';
import castArrayIfPresent from '@tekion/tekion-base/utils/castArrayIfPresent';
import { getMomentValueOf } from '@tekion/tekion-base/utils/dateUtils';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import filterGroupReader, { filterReader } from '../readers/FilterGroup';
import FILTER_TYPES from '../constants/filterSection.filterTypes';
import getTypeOfFilter from './filterSection.typeOfFilter';
var makeFilterRequestDTO = function makeFilterRequestDTO(_ref) {
  var operator = _ref.operator,
    type = _ref.type,
    values = _ref.values,
    nestedFilter = _ref.nestedFilter,
    orFilters = _ref.orFilters;
  var extraFilters = _omitBy({
    nestedFilter: nestedFilter,
    orFilters: orFilters
  }, _isNil);
  return _objectSpread({
    operator: operator,
    field: type,
    values: values
  }, extraFilters);
};
var getPresetIdFromDateFilter = compose(_head, _property('additional'));
var getDateFilterDTO = function getDateFilterDTO(filter) {
  var presetId = getPresetIdFromDateFilter(filter);
  var operator = filterReader.operator(filter);
  var type = filterReader.type(filter);
  var dateFilterValues = presetId ? castArrayIfPresent(presetId) : filterReader.values(filter);
  var filterRequestDTO = makeFilterRequestDTO({
    operator: operator,
    type: type,
    values: dateFilterValues
  });
  return filterRequestDTO;
};
var getMonthPickerFilterDTO = function getMonthPickerFilterDTO() {
  var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var operator = filterReader.operator(filter);
  var type = filterReader.type(filter);
  var values = _map(filter.values, getMomentValueOf);
  var filterRequestDTO = makeFilterRequestDTO({
    operator: operator,
    type: type,
    values: values
  });
  return filterRequestDTO;
};
var getFilterRequestDTO = function getFilterRequestDTO(filter) {
  var operator = filterReader.operator(filter);
  var type = filterReader.type(filter);
  var values = filterReader.values(filter);
  var nestedFilter = filterReader.nestedFilter(filter);
  var orFilters = filterReader.orFilters(filter);
  var filterRequestDTO = makeFilterRequestDTO({
    operator: operator,
    type: type,
    values: values,
    nestedFilter: nestedFilter,
    orFilters: orFilters
  });
  return filterRequestDTO;
};
export var mapFilterPayload = function mapFilterPayload(filterTypes) {
  return function (filter) {
    var typeOfFilter = getTypeOfFilter(filterTypes, filter);
    if (typeOfFilter === FILTER_TYPES.DATE) {
      var updatedDateFilter = getDateFilterDTO(filter);
      return updatedDateFilter;
    }
    if (typeOfFilter === FILTER_TYPES.MONTH_PICKER) {
      return getMonthPickerFilterDTO(filter);
    }
    var filterRequestDTO = getFilterRequestDTO(filter);
    return filterRequestDTO;
  };
};
export var mapFilterFromResponse = function mapFilterFromResponse(filter) {
  var extraFilters = _omitBy({
    nestedFilter: filterReader.nestedFilter(filter),
    orFilters: filterReader.orFilters(filter)
  }, _isNil);
  return _objectSpread({
    operator: filterReader.operator(filter),
    type: filterReader.field(filter),
    values: filterReader.values(filter)
  }, extraFilters);
};
export var getFiltersForApi = function getFiltersForApi(filters, filterTypes) {
  return _map(filters, mapFilterPayload(filterTypes));
};
export var getFiltersFromResponse = function getFiltersFromResponse(filters) {
  return _map(filters, mapFilterFromResponse);
};
export var getFilterGroupPayload = function getFilterGroupPayload(_ref2) {
  var groupName = _ref2.groupName,
    values = _ref2.values,
    isAppliedFilter = _ref2.isAppliedFilter,
    filterTypes = _ref2.filterTypes,
    defaultGroupIdentifier = _ref2.defaultGroupIdentifier,
    nonRenamable = _ref2.nonRenamable,
    nonDeletable = _ref2.nonDeletable;
  var filters = getFiltersForApi(values, filterTypes);
  var extraKeys = _omitBy({
    defaultGroupIdentifier: defaultGroupIdentifier,
    nonRenamable: nonRenamable,
    nonDeletable: nonDeletable
  }, _isNil);
  return _objectSpread({
    groupName: groupName,
    filters: filters,
    selected: isAppliedFilter
  }, extraKeys);
};
export var getFilterGroup = function getFilterGroup(filterGroup, filters) {
  return {
    id: filterGroupReader.id(filterGroup),
    name: filterGroupReader.groupName(filterGroup),
    filters: filters
  };
};
export var getModifiedDefaultFilters = function getModifiedDefaultFilters(changedFilters, existingDefaultFilters) {
  return _map(existingDefaultFilters, function (filter) {
    var modifiedFilter = _find(changedFilters, function (_ref3) {
      var type = _ref3.type;
      return type === filter.type;
    });
    if (modifiedFilter) return modifiedFilter;
    return filter;
  });
};
var mapRowToFilter = _curry(function (values, rowId) {
  var filter = values[rowId];
  if (filter.type === FILTER_TYPES.MONTH_PICKER) {
    return _objectSpread(_objectSpread({}, filter), {}, {
      values: _head(filter.values)
    });
  }
  return filter;
});
export var getFilterFromFormValues = function getFilterFromFormValues(sections, values) {
  var rows = _get(sections, '0.rows');
  var filters = _map(rows, mapRowToFilter(values));
  return filters;
};